import { IState } from 'legacy/lut/store'

export const selectPlanningWizardState = (state: IState) => state.partner360.planningWizard
